<template>
	<div class="customerUserList">
		<v-content>
			<v-container fluid>
              <center><img class="imgLoader" src="../../shared/assets/images/3dloader.gif" v-if="customersLoaded == false" /></center>
              <v-flex xs3>
                <div class="relative">
                  <a v-if="search != ''" @click.prevent="fncClearSearch" class="searchTypeClear"><i class="material-icons searchTypeClearText">close</i></a>
                  <v-text-field label="Search" @input="fncFilterUsers" v-if="customersLoaded == true && search != ''" solo single-line v-model="search"></v-text-field>
                  <v-text-field append-icon="search" label="Search" @input="fncFilterUsers" v-if="customersLoaded == true && search == ''" solo single-line v-model="search"></v-text-field><br />
                </div>
              </v-flex>
				<v-data-table ref="customerTable" :headers="headers" v-if="customersLoaded == true" id="hello" :items="filteredUsers" item-key="id" class="elevation-1 mainTable" disable-initial-sort :rows-per-page-items="[20,40,60,80,100]">
					<template slot="items" slot-scope="props">
                      <tr>
                        <td width="70%" v-if="props.expanded == true" @click="props.expanded = !props.expanded" ><i v-if="props.item.branch.length > 0" class="material-icons showHide">arrow_downward</i>{{ fncCompanyName(props.item) }}</td>
                        <td width="70%" v-else @click="props.expanded = !props.expanded" ><i v-if="props.item.branch.length > 0" class="material-icons showHide">arrow_forward</i>{{ fncCompanyName(props.item) }}</td>
                        <td width="20%"  v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1"><a @click.prevent="fncViewCompany(props.item.id)"><i class="material-icons">account_box</i></a><a @click.prevent="fncViewCompanyUsers(props.item.id)"><i class="material-icons">list</i></a></td>
                        <td width="10%"  v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1"><a @click.prevent="fncEditCompany(props.item)"><i class="material-icons">edit</i></a></td>
                        <!--<td width="10%"  v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1"><a @click.prevent="fncDeleteUser(props.item.attr.id, 'company')"><i class="material-icons">delete_forever</i></a></td>                      -->
                      </tr>
                    </template>
          <template slot="expand" slot-scope="props">
                      <v-data-table :headers="headersSub" :items="props.item.branch" hide-actions class="elevation-1 subTable1 minTable" disable-initial-sort :rows-per-page-items="[20,40,60,80,100]">
                        <template slot="items" slot-scope="props">
                          <tr>
                            <td width="30%" >{{ props.item.label.replace(/"/g, '') }}</td>
                            <td width="25%" v-html="fncStoreAccount( props.item )"></td>
                            <td width="10%" >{{ props.item.contactno }}</td>
                            <td width="20%" >{{ props.item.email }}</td>
                            <td width="10%">
                              <v-menu offset-y>
                                <v-toolbar-side-icon slot="activator"></v-toolbar-side-icon>
                                <v-list>
                                  <v-list-tile @click.prevent="fncLinkUsers(props.item.id)">
                                    <v-list-tile-title>
                                      <a v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1">Link Users</a>
                                    </v-list-tile-title>
                                  </v-list-tile>
                                  <v-list-tile @click.prevent="fncEditPricelist(props.item.id)">
                                    <v-list-tile-title>
                                      <a v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1">Link User Pricelists</a>
                                    </v-list-tile-title>
                                  </v-list-tile>
                                  <v-list-tile @click.prevent="fncEditPassword(props.item.id, props.item.email)">
                                    <v-list-tile-title>
                                      <a v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1">Update Password</a>
                                    </v-list-tile-title>
                                  </v-list-tile>
                                  <v-list-tile @click.prevent="fncViewUser(props.item.id, props.item.region)">
                                    <v-list-tile-title>
                                      <a v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1">User Details</a>
                                    </v-list-tile-title>
                                  </v-list-tile>
                                </v-list>
                              </v-menu>
                            </td>
                            <td width="5%"  v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1"><a @click.prevent="fncEditUser(props.item)"><i class="material-icons">edit</i></a></td>
                            <!--<td width="5%"  v-if="objAuthorize.privileges.indexOf('VIEW_USERS') !== -1"><a @click.prevent="fncDeleteUser(props.item.id, 'user')"><i class="material-icons">delete_forever</i></a></td>-->
                          </tr>
                        </template>
                      </v-data-table>
                    </template>
</v-data-table>
			</v-container>
		</v-content>
	</div>
</template>

<script>

  import { mapGetters } from 'vuex';
  import Modal from '@/components/shared/modal';

  export default {
    name: 'UserList',
    intRoleEdit: 0,
    data() {
      return {
        search: '',
        filteredUsers: [],
        headers: [
          { text: 'Name', value: 'label', width: '70%' },
          { text: 'Company Details', value: 'details', width: '20%' },
          { text: 'Edit', value: 'edit', width: '10%' }
          /*{ text: 'Delete', value: 'delete', width: '10%' }*/
        ],
        headersSub: [
          { text: 'Full Name', value: 'name', width: '30%' },
          { text: 'Account Details', value: 'registration_no', width: '25%' },        
          { text: 'Contact No', value: 'registration_no', width: '10%' },        
          { text: 'Email Address', value: 'email', width: '20%' },
          { text: 'User Actions', value: 'actions', width: '10%' },
          { text: 'Edit', value: 'edit', width: '5%' }
        ]
      }
    },
    methods: {
      fncStoreAccount( item ) {
        return item.account_numbers;        
      },
      fncClearSearch() {
        this.search = '';
        this.fncFilterUsers();
      },
      fncFilterUsers() {
        this.$store.commit({
          type: 'fncFilterUsers',
          search: this.search,
          uType: 'customer'
        })
      },
      fncExpandProps(props, companyId) {
        this.$store.commit('setCurrentUserCompany', companyId);
        return props.expanded = !props.expanded;
      },
      fncDeleteUser(userId, type) {
        var deleteUser = confirm('Are you sure you want to delete this user?');
        if (deleteUser === true) {
          this.$store.dispatch({
            type: 'fncDeleteUser',
            userId: userId,
            context: 2,
            deleteType: type
          })
        }
      },
      fncEditPassword(userId, userEmail) {
        var updatePassword = confirm('Are you sure you want to update the users password?');
        if (updatePassword === true) {
          this.$store.dispatch({
            type: 'fncUpdateUserPassword',
            userId: userId,
            userEmail: userEmail
          })
        }
      },
      fncEditPricelist(userId) {
        this.$store.dispatch({
          type: 'fncEditUserPricelist',
          userId: userId
        })
      },
      fncEditCompany(userId) {
        this.$store.dispatch({
          type: 'fncEditUserCompanies',
          userId: userId,
          listType: 1,
          context: 2
        })
      },
      fncViewCompany(companyId) {
         this.$store.dispatch('fncViewCompany', companyId)
      },
      fncLinkUsers(userId) {
        this.$store.commit('fncEmptyUserLinks');
        var modalDetails = { title: 'Link Users', component: 'modal-user-link', mstate: true, params: { userId: userId, userType: 1 } };
        this.$store.commit({
          type: 'setModal',
          details: modalDetails
        });
      },
      fncEditUser(user) {
        this.$store.dispatch('fncSetEditUser', user);
        this.$store.dispatch('fncPopulateUserRegions');
        this.$store.dispatch('fncSetupUserCreate', '');
      },
      fncEditCompany(company) {

        if( company.surname ) {
          this.$store.dispatch('fncSetEditUser', company);
          this.$store.dispatch('fncPopulateUserRegions');
          this.$store.dispatch('fncSetupUserCreate', '');
        } else {
          this.$store.commit('fncSetObjCompanyEdit', company);
          //this.$store.dispatch('fncLoadCompany', company.id);
          this.$store.dispatch('fncPopulateUserRegions');
          this.$store.dispatch('fncSetupUserCreate', '');
          // var companyName = company.attr.name.replace(/<(?:.|\n)*?>/gm, '');
          var companyName = company.name.replace(/<(?:.|\n)*?>/gm, '');
          var modalDetails = { title: 'Edit company - ' + companyName, component: 'modal-company-update', mstate: true, params: { context: 1 } };
          this.$store.commit({
            type: 'setModal',
            details: modalDetails
          });
        }
      },
      fncViewUser(userId, regions) {
        this.$store.dispatch({
          type: 'fncViewUser',
          userId: userId,
          regions: regions
        })
      },
      fncCompanyName(companyName) {
        if ( companyName.attr != null ) {
          var cName = companyName.attr.name.replace(/"/g, '');
          return cName.replace(/<(?:.|\n)*?>/gm, '');
        } else if ( companyName.surname != null && companyName.surname != undefined && companyName.surname != '' ) {
          var cName = (companyName.name + ' ' + companyName.surname).replace(/"/g, '');
          return cName.replace(/<(?:.|\n)*?>/gm, '');
        } else {
          var cName = companyName.name;
          var cName = companyName.name.replace(/"/g, '');
          //var cName = JSON.parse(companyName.name).replace(/"/g, '');
          return cName.replace(/<(?:.|\n)*?>/gm, '');
        }

      },
      fncApplySearchExpanded() {
        var self = this;
        this.$nextTick(function() {
          if (self.$refs.customerTable == undefined) {
            return;
          }

          var expanded = {};
          for (var k in self.filteredUsers) {
            if (self.filteredUsers[k]._searchExpanded == true && self.filteredUsers[k].id != undefined && self.filteredUsers[k].id != null) {
              expanded[self.filteredUsers[k].id] = true;
            }
          }

          self.$refs.customerTable.expanded = expanded;
        });
      },
      fncViewCompanyUsers( id ) {

        this.$store.dispatch( 'fncViewCompanyUsers', id );

      }
    },
    computed: {
      ...mapGetters([
        'objAuthorize',
        'customerUsers',
        'customerUserSearch',
        'customersLoaded'
      ])
    },
    beforeMount() {
      this.$store.dispatch({
        type: 'fncPopulateUsers',
        context: 2
      });

      this.$store.dispatch('fncUserListShort');
    },
    watch: {
      customerUsers() {
        this.filteredUsers = this.customerUsers;
        this.fncApplySearchExpanded();
      },
      customerUserSearch() {
        if (this.search == '') {
          this.filteredUsers = this.customerUsers;
        } else {
          this.filteredUsers = this.customerUserSearch;
        }
        this.fncApplySearchExpanded();
      }
    }
  }
</script>

<style scoped>
  @import '../../shared/assets/css/shared.css'
</style>
